module.exports = __webpack_public_path__ + "static/media/now-3.66448423.png";